import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Picker, List, Toast, ListView } from 'antd-mobile';
import Http from '../../config/axiosUtils';
import TeamItem from '../../components/team/TeamItem';
import Swiper from '../../components/activity/Swiper';
import Award from '../../components/activity/Award';
import '../../assets/scss/Home/home.scss';
import { setStore, getStore } from '../../config/storage';
import config from '../../config/config';
import HomeHotRow from '../../components/Home/HomeHotRow';
import stopImg from '../../assets/images/home/stop@2x.png';

class Home extends Component {

  constructor() {
    super();
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2,
    });
    this.state = {
      initData: {},
      advertisementBeanList: [], //广告列表
      indexCustomerInfo: {}, //客户信息
      indexIncomeInfo: {}, // 收益信息
      indexMessageInfo: {}, //消息公告
      indexTeamInfo: {}, //团队信息
      accountList: [], //账号列表
      accountId: '', //账号Id
      isHideMoney: false, //是否隐藏金额
      dataSource: dataSource, //列表初始化
      initDataSource:[],
      dataArray:[],//热门列表原始数据
      hotHeight:0,
    }
  }

  componentDidMount() {
    // 渲染页面前判断url是否携带token,如果有就替换本地token
    if (window.location.href.indexOf('token') !== -1) {
      const transmitToken = this.getUrlCode('token')
      localStorage.setItem('token',JSON.stringify(transmitToken))
    }
    this.setState({
      isHideMoney: getStore('eyeStatus')
    });
    this.fetchData();
    this.fetchAccount();
    this.fetchHotList();
  }

  //渲染首页
  fetchData = async () => {
    const path = '/spread/web/index/info';
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        initData: res.data,
        advertisementBeanList: res.data.advertisementBeanList,
        indexCustomerInfo: res.data.indexCustomerInfo,
        indexIncomeInfo: res.data.indexIncomeInfo,
        indexMessageInfo: res.data.indexMessageInfo,
        indexTeamInfo: res.data.indexTeamInfo,
      });
      setStore('teamLevel', res.data.teamLevel);
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //获取账户列表
  fetchAccount = async () => {
    const path = '/spread/web/user/account/getUserAccounts';
    const res = await Http.get(path);
    if (res.code === 0) {
      const newArr = res.data.map(a => {
        let arr = [];
        arr.push({label: a.accountDesc, value: a.accountId});
        return arr[0];
      });
      this.setState({
        accountList: newArr
      })
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //获取热门产品列表
  fetchHotList = async () => {
    const path = '/spread/web/index/hotProductList';
    const res = await Http.get(path);
    if (res.code === 0) {
      if (res.data.length !==0 ) {
        this.setState({
          dataArray:res.data,
          dataSource: this.state.dataSource.cloneWithRows(res.data),
          hotHeight: (this.state.dataArray.length > 4) ? 4*123.4 : (123.4 * res.data.length) - 12,
        });
      }
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //打开切换账户
  accountShow = (status) => {
    if (status === true) {
      if (getStore('accountId')) {
        this.setState({
          accountId: getStore('accountId')
        })
      }
      this.fetchAccount();
    }
  }

  //切换账户时选中
  onChangeAccount = (id) => {
    setStore('accountId', id);
    this.setState({
      accountId: id,
    });
    this.switchAccount(id);
  };

  switchAccount = (id) => {
    Toast.loading('切换中，请稍后...', 0.5, async () => {
      const path = `/spread/web/user/account/switchAccount/${id}`;
      const res = await Http.get(path);
      if (res.code === 0) {
        Toast.hide();
        this.fetchData();
      } else {
        Toast.fail(res.msg, 2);
      }
    });
  }

  hideMoney = () => {
    this.setState({
      isHideMoney: !this.state.isHideMoney
    }, () => {
      setStore('eyeStatus', this.state.isHideMoney);
    })
  }

  //邀请好友
  goInviteHome = (type) => {
    window.location.href = `${config.backendUrl}/inviteHome/${type}`;
  }

  getUrlCode = (name) => { 
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substring(1).match(reg)
    if (r != null) return decodeURIComponent(r[2])
    return null
  }

  render() {
    const incomeObj = {
      allCount: this.state.indexIncomeInfo.myAllIncome,
      monthCount: this.state.indexIncomeInfo.myMonthIncome,
      todayCount: this.state.indexIncomeInfo.myTodayIncome,
    }
    const hasGroup = this.state.initData.teamLevel === 1 || this.state.initData.teamLevel === 2;
    const separator = (sectionID, rowID) => {
      return(
        <div
          key={`${sectionID}-${rowID}`}
          style={{
            backgroundColor: '#F5F5F9',
            height: (rowID === this.state.dataArray.length-1) ? 0 : 8,
          }}
        />
      );
    };
    const row = (rowData, rowID) => {
      return (
        <HomeHotRow rowData={rowData}></HomeHotRow>
      );
    }
    return (
      <div className='home'>
        <Helmet><title>个人中心</title></Helmet>
        <section className='head'>
          <div className='head-top'>
            <div className='top-left'>
              <div className='top-left-avatar'></div>
              <div className='top-left-name'>
                <div className='top-left-title'>
                  <div className='noWrap'>{this.state.initData.name}</div>
                  {this.state.initData.teamLevelName && <span>{this.state.initData.teamLevelName}</span>}
                  {/* <img src={nameImg} alt="" /> */}
                </div>
                <div className='top-left-tag'>
                  <div>ID: {this.state.initData.accountId}</div>
                  <Link to="/profile">
                    <div className='top-left-profile'>个人资料</div>
                  </Link>
                </div>
              </div>
            </div>
            {
              this.state.accountList.length > 1 &&
              <div className='top-right'>
                <i className='iconfont icon-qiehuanzhanghao'></i>切换账号
                <div className='common-pick account-pick'>
                  <Picker
                    data={this.state.accountList}
                    value={this.state.accountId}
                    cols={1}
                    onVisibleChange={this.accountShow}
                    onChange={this.onChangeAccount}
                  >
                    <List.Item arrow="horizontal"></List.Item>
                  </Picker>
                </div>
              </div>
            }
          </div>
          {
            this.state.indexMessageInfo.latestMessage &&
            <Link to='/noticeHome'>
              <div className='head-bottom'>
                {this.state.indexMessageInfo.latestUnread && <i className='no-read'></i>}
                <div className='noWrap'>{this.state.indexMessageInfo.latestMessage}</div>
                <i className='iconfont icon-arrrow_w'></i>
              </div>
            </Link>
          }
        </section>
        <section className='content'>
          <section className='content-common money'>
            <div className='content-title'>
              <div>账户余额(元)<i className={`iconfont icon-${this.state.isHideMoney ? 'bukejian' : 'zhanshi'}`} onClick={this.hideMoney}></i></div>
              <Link to='/walletHome'>
                <i className='iconfont icon-arrrow'></i>
              </Link>
            </div>
            <div className='money-amount'>{this.state.isHideMoney ? '****' : this.state.initData.amount}</div>
          </section>
          <section className='content-common income'>
            <Link to='/incomeHome'>
              <div className='content-title'>
                <div>我的收益(元)</div>
                <i className='iconfont icon-arrrow'></i>
              </div>
            </Link>
            <TeamItem
              keyArr={['累计总收益(元)', '当月收益(元)', '今日收益(元)']}
              itemObj={incomeObj}
              isHomeHide={this.state.isHideMoney}>
            </TeamItem>
          </section>
          <section className='domain'>
            <div className='domain-name'>我的地盘</div>
            <div className='domain-wrap'>
              <div className='domain-wrap-custom'>
                <div>我的客户<Link to='/customHome'>
                    <i className='iconfont icon-arrrow'></i>
                  </Link></div>
                <div>总客户数 {this.state.indexCustomerInfo.myAllCustomerNum}</div>
                <div onClick={this.goInviteHome.bind(this, 'custom')}>邀请客户</div>
              </div>
               {
                 this.state.indexTeamInfo.showStatus && <div className='domain-wrap-invite' >
                <div>{this.state.indexTeamInfo.teamName}{this.state.indexTeamInfo.disabled && hasGroup ? <img src={stopImg} alt="" /> : ''}
                  <Link to={hasGroup ? '/groupHome' : '/groupDetail?from=isInvite'}>
                    <i className='iconfont icon-arrrow'></i>
                  </Link>
                </div>
                <div>{hasGroup ? `团队成员 ${this.state.indexTeamInfo.teamAccountCount}` : `创业合伙人 ${this.state.indexTeamInfo.referrerAccountCount}`}</div>
                <div onClick={this.goInviteHome.bind(this, `${hasGroup ? 'team' : 'partner'}`)}>{hasGroup ? '邀请团队' : '邀请合伙人'}</div>
              </div>
               }
            </div>
          </section>
          {this.state.dataArray.length > 0 && <section className='act'>
            <div className='act-name'>热门产品</div>
            <ListView
              ref={(el) => (this.lv = el)}
              dataSource={this.state.dataSource}
              renderRow={row}
              renderSeparator={separator}
              onEndReachedThreshold={10}
              style={{ 'height': `${this.state.hotHeight}px`, overflow: "auto" }}
            />
          </section> }
          <section className='act'>
            <div className='act-name'>推广活动</div>
            <Swiper></Swiper>
          </section>
          <section className='act'>
            <div className='act-name'>推广助手</div>
            <Award></Award>
          </section>
        </section>
      </div>
    )
  }
}

export default Home;
